module.exports = __webpack_public_path__ + "static/media/hlavni-oltar-zezadu.ca7e3cdd.jpg";